import { createI18n } from 'vue-i18n'
import it from '@/locales/it.json'
import en from '@/locales/en.json'

const savedLocale = typeof localStorage !== 'undefined' ? localStorage.getItem('locale') : null
const defaultLocale = savedLocale === 'en' || savedLocale === 'it' ? savedLocale : 'it'

export default createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: { it, en }
})
